import { ReactNode } from 'react'

import { Text } from '@cash-me/react-components'

import {
  BuildingSearchIcon,
  BullseyeIcon,
  ContractIcon,
  DollarShinyIcon,
  PeopleGraphIcon
} from 'components/new-icons'

import * as S from './styles'

const IMAGES_PATH = `${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/credito-para-condominio`

export type StepCardProps = {
  id: string
  title: string
  image: string
  imageAlt: string
  icon: ReactNode
  content: (isTablet: boolean) => ReactNode
}

export const condominiumCreditSteps: StepCardProps[] = [
  {
    id: 'identifica-necessidade',
    title: 'O condomínio identifica a necessidade',
    image: `${IMAGES_PATH}/condominio-identifica-necessidade.webp`,
    imageAlt: 'Homem consultando um tablet em frente à fachada de um edifício residencial',
    icon: <BullseyeIcon color="var(--colors-blue-icon-strong)" />,
    content: isTablet => (
      <S.TextWrapper>
        <Text as="h3" size={isTablet ? 'heading5' : 'heading4'} color="var(--colors-blue-text-strong)">
          O condomínio identifica a necessidade
        </Text>
        <Text color="var(--colors-blue-text-strong)">
          <b>O síndico</b> ou administradora <b>e os condôminos definem o projeto</b>, estimam o orçamento e{' '}
          <b>levantam o valor necessário</b> para a execução.
        </Text>
      </S.TextWrapper>
    )
  },
  {
    id: 'aprovacao-assembleia',
    title: 'A contratação é discutida e aprovada em assembleia',
    image: `${IMAGES_PATH}/assembleia-aprova-contratacao.webp`,
    imageAlt: 'Mulher sorrindo ao acompanhar a proposta pelo notebook em casa',
    icon: <PeopleGraphIcon color="var(--colors-blue-icon-strong)" />,
    content: isTablet => (
      <S.TextWrapper>
        <Text as="h3" size={isTablet ? 'heading5' : 'heading4'} color="var(--colors-blue-text-strong)">
          A contratação é discutida e aprovada em assembleia
        </Text>
        <Text color="var(--colors-blue-text-strong)">
          A operação deve ser apresentada aos condôminos e{' '}
          <b>aprovada de acordo com as regras aplicáveis ao condomínio.</b> O síndico conduz essa etapa e organiza a
          documentação necessária.
        </Text>
      </S.TextWrapper>
    )
  },
  {
    id: 'analise-cashme',
    title: 'A CashMe realiza a análise',
    image: `${IMAGES_PATH}/cashme-realiza-analise.webp`,
    imageAlt: 'Especialista da CashMe analisando informações em um notebook no escritório',
    icon: <BuildingSearchIcon color="var(--colors-blue-icon-strong)" />,
    content: isTablet => (
      <S.TextWrapper>
        <Text as="h3" size={isTablet ? 'heading5' : 'heading4'} color="var(--colors-blue-text-strong)">
          A CashMe realiza a análise
        </Text>
        <Text color="var(--colors-blue-text-strong)">
          São avaliadas as informações financeiras, os documentos do empreendimento e as{' '}
          <b>características da operação</b> para verificar a viabilidade do crédito.
        </Text>
      </S.TextWrapper>
    )
  },
  {
    id: 'condicoes-formalizadas',
    title: 'As condições são definidas e formalizadas',
    image: `${IMAGES_PATH}/condicoes-formalizadas.webp`,
    imageAlt: 'Duas pessoas se cumprimentando com aperto de mão sobre a mesa após fechar um acordo',
    icon: <ContractIcon color="var(--colors-blue-icon-strong)" />,
    content: isTablet => (
      <S.TextWrapper>
        <Text as="h3" size={isTablet ? 'heading5' : 'heading4'} color="var(--colors-blue-text-strong)">
          As condições são definidas e formalizadas
        </Text>
        <Text color="var(--colors-blue-text-strong)">
          Com a aprovação, o condomínio conhece as condições da operação e{' '}
          <b>segue para a formalização e assinatura do contrato.</b>
        </Text>
      </S.TextWrapper>
    )
  },
  {
    id: 'recursos-liberados',
    title: 'Os recursos são liberados',
    image: `${IMAGES_PATH}/recursos-liberados.webp`,
    imageAlt: 'Homem comemorando ao consultar um tablet em frente a um edifício',
    icon: <DollarShinyIcon color="var(--colors-blue-icon-strong)" />,
    content: isTablet => (
      <S.TextWrapper>
        <Text as="h3" size={isTablet ? 'heading5' : 'heading4'} color="var(--colors-blue-text-strong)">
          Os recursos são liberados
        </Text>
        <Text color="var(--colors-blue-text-strong)">
          Depois da conclusão das etapas necessárias,{' '}
          <b>o crédito é liberado conforme as condições contratadas</b> para que o condomínio possa avançar com o
          projeto.
        </Text>
      </S.TextWrapper>
    )
  }
]
